<script lang="ts" setup>
import { useEnvironmentStore } from '@/stores/environmentStore'
import { computed, onMounted, ref, toRef } from 'vue'
import { useRouter } from 'vue-router'
import userService from '@/services/user.service'
import type { User } from '@/types'

const router = useRouter()

const environmentStore = useEnvironmentStore()
const tmpUser = ref<User>()

onMounted(async () => {
  tmpUser.value = await userService.init() as User
})

const technicalError = ref(false)

const props = defineProps({
  campaignCode: String
})

const campaignCode = toRef(props.campaignCode);

function confirm() {
  if (tmpUser.value == undefined) {
    technicalError.value = true
    return
  }

  tmpUser.value.password = pin.value
  tmpUser.value.campaignCode = campaignCode.value

  environmentStore.confirmUser(tmpUser.value.token, tmpUser.value).then((response) => {
    if (response) {
      environmentStore.verifyToken(true).then(() => {
        router.push({ name: 'home' })
      })
    } else {
      technicalError.value = true
    }
  })
}

const pin = ref('')
const invalidPin = computed(() => {
  return pin.value.length !== 3
})
</script>

<template>
  <div v-if="technicalError">Teknisk feil ved opprettelse av bruker.</div>
  <div class="content-wrapper" v-if="tmpUser">
    <div class="input-wrapper">
      <div class="row">
        <div class="column">
          <span>{{ $t('input.label.your-id') }}</span>
          <div class="login">
            {{ tmpUser.username }}
          </div>
        </div>
        <div class="column">
          <span>{{ $t('input.label.PIN') }}</span>
          <input class="pin" v-model="pin" placeholder="000" maxlength="3" inputmode="numeric" />
        </div>
      </div>
      <div class="row" v-if="campaignCode != null && campaignCode !=  undefined && campaignCode != '' && campaignCode.trim().length > 0">
        <div class="column">
          <span>Kampanje: {{ campaignCode }}</span>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="warn" @click="$router.push({ name: 'login' })">
        {{ $t('label.cancel') }}
      </button>
      <button class="ok" @click="confirm()" :disabled="invalidPin">{{ $t('label.ok') }}!</button>
    </div>
  </div>
</template>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

input.pin {
  padding: 0 0 0 8px;
  width: 52px;
  border-radius: 8px;
  color: #333;
  background-color: white;
  font-weight: bold;
}
input:focus {

  border-bottom: 1px solid black;
  outline: auto;
}
.input-wrapper {
  margin: auto;
  display: flex;
  flex-direction: column;
}

button.accept:disabled {
  background-color: gray;
}

.login {
  background-color: #fafafa;
  border-radius: 8px;
  line-height: 1.5;
  color: #333;
  padding: 0 0 0 28px;
  width: 120px;
  font-weight: bold;
  font-size: 1.3em;
}
</style>
